module.exports = "/_next/static/images/prefooter-blog@2x_b71d51b1ea801504a72a5069dda82b1e.webp";